import { useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../../../ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "../../../ui/command";

export const SearchSelect = ({ value, onChange, options, placeholder, testId, excludeValue }) => {
  const [open, setOpen] = useState(false);
  const filtered = excludeValue ? options.filter(o => o !== excludeValue) : options;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testId}
          className="flex-1 flex items-center justify-between px-3 py-2.5 bg-black/40 border border-white/[0.08] rounded-xl text-sm text-slate-200 hover:border-violet-500/30 transition-all min-w-0">
          <span className={value ? "text-slate-100 truncate" : "text-slate-400 truncate"}>{value || placeholder}</span>
          <ChevronsUpDown className="w-3.5 h-3.5 text-slate-400 ml-1.5 flex-shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-[#0a0f1a] border-white/[0.08] shadow-2xl" side="bottom" align="start" sideOffset={4}>
        <Command className="bg-transparent">
          <CommandInput placeholder="Search..." className="text-xs text-slate-200 h-9" />
          <CommandList className="max-h-[220px]">
            <CommandEmpty className="text-xs text-slate-400 py-3">No match found</CommandEmpty>
            <CommandGroup>
              {filtered.map(o => (
                <CommandItem key={o} value={o} onSelect={() => { onChange(o); setOpen(false); }}
                  className="text-xs text-slate-300 cursor-pointer hover:bg-white/[0.05] aria-selected:bg-violet-500/10 aria-selected:text-violet-300">
                  {value === o && <Check className="w-3 h-3 text-violet-400 mr-1.5" />}
                  {o}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SearchSelect;
